export enum LoggerTypeEnum {
    Console,
}
